import * as React from 'react';

import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";

import {Dialogs} from "./types";

interface FooterProps {
    onSubmit: (event: React.MouseEvent<HTMLButtonElement>) => void,
    onHide: () => void
    disabled: boolean
}

const Footer = ({onSubmit, onHide, disabled = false}: FooterProps) => {
    return (
        <div>
            <Button label='Отменить' className={'p-button-danger'}  onClick={onHide} />
            <Button disabled={disabled} label='Отправить' className={'p-button-success'} onClick={onSubmit} />
        </div>
    )
}

interface State {
    message: string
}

interface Props extends Dialogs {
    onSubmit: (message: string) => void
}

export class RespondRequest extends React.Component<Props, State> {
    state = {
        message: ''
    }

    handleTextarea = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        this.setState({message: event.currentTarget.value})
    }

    handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        this.props.onSubmit(this.state.message);
    }

    render() {
        return (
            <Dialog
                header="Ответить на заявку"
                className='custom-dialog'
                visible={this.props.visible}
                onHide={this.props.onHide}
                closable={false}
                draggable={false}
                style={{maxWidth: '700px', width: '100%'}}
                footer={Footer({
                    onSubmit: this.handleSubmit,
                    onHide: this.props.onHide,
                    disabled: !this.state.message.length
                })}
            >
                <div className="form-group">
                    <textarea
                        className="form-control"
                        value={this.state.message}
                        onChange={this.handleTextarea}
                        placeholder={'Введите ответ'}
                    />
                </div>
            </Dialog>
        );
    }
}

